import { styled } from '@mui/material';
import { EmptyStateWrapper } from '../EmptyState';

export const ScreenWrapper = styled(EmptyStateWrapper)({
  height: '100vh',
  margin: 0,
});
